import React from 'react'
import './emptyFile.css'
import Empty_Pic from '../imageSrc/file_empty.png'
import Search_Empty from '../imageSrc/search_empty.png'

class EmptyView extends React.Component {
    constructor(props) {
        super(props)
    }

    getEmptyPic = () => {
        if (this.props.type === 'dir') {
            return Empty_Pic;
        } else if (this.props.type === 'search') {
            return Search_Empty;
        }
    };

    render(){
        let visible_state = this.props.visible?'inline':'none';
        return(
            <div className='empty_frame' style={{display:visible_state}}>
                <img src={this.getEmptyPic()} className='empty_img_style'/>
            </div>
        );
    }
}

export default EmptyView